module.exports = __webpack_public_path__ + "img/toplogo.46f0bde4.jpg";